function toKebabCase(str: string): string {
  return str.replaceAll(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}

export function toKebabParams(baseUrl: string, params: Record<string, string | number | null | undefined>): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.append(toKebabCase(key), value.toString());
    }
  });

  return `${baseUrl}?${searchParams.toString()}`;
}
